<template>
    <div>
        <Title>基本信息</Title>
        <div class="panel">
            <div class="label">项目编号</div>
            <div class="value1">{{ extra.prjNo }}</div>
            <div class="label">备案编号</div>
            <div class="value2">{{ extra.filingNo }}</div>

            <div class="label">项目名称</div>
            <div class="value1">{{ extra.prjName }}</div>
            <div class="label">项目类型</div>
            <div class="value2">
                <DataDictFinder dictType="cosys.projectType" :dictValue="extra.prjType" />
            </div>

            <div class="label">项目类别</div>
            <div class="value1">
                <DataDictFinder dictType="cosys.prjCategory" :dictValue="extra.prjCategory" />
            </div>
            <div class="label">评审方式</div>
            <div class="value2">
                会签式
            </div>

            <div class="label">生产部门</div>
            <div class="value1">{{ extra.prodDeptName }}</div>
            <div class="label">设计阶段</div>
            <div class="value2">
                <DataDictFinder dictType="cosys.designPhase" :dictValue="extra.designPhase" />
            </div>

            <div class="label">投资额(万元)</div>
            <div class="value1">{{ extra.investment }}</div>
            <div class="label">业主要求开始时间</div>
            <div class="value2">{{ extra.ownerStartDate | dateFormat }}</div>

            <div class="label">业主要求结束时间</div>
            <div class="value1">{{ extra.ownerEndDate | dateFormat }}</div>
            <div class="label">登记人</div>
            <div class="value2">{{ extra.registerUserName }}</div>

        </div>
        <Title>项目信息</Title>
        <div class="panel">
            <div class="label">委托单位</div>
            <div class="value1">{{ extra.entrustUnitName }}</div>
            <div class="label">单位地址</div>
            <div class="value2">{{ extra.unitAddress }}</div>

            <div class="label">国家</div>
            <div class="value1">{{ countryName }}</div>
            <div class="label">所属区域</div>
            <div class="value2">{{ areaName }}</div>

            <div class="label">联系人</div>
            <div class="value1">{{ extra.contactPerson }}</div>
            <div class="label">联系电话</div>
            <div class="value2">{{ extra.phone }}</div>

            <div class="label">谈判人</div>
            <div class="value1">{{ extra.negotiatorName }}</div>
            <div class="label">项目负责人</div>
            <div class="value2">{{ extra.prjLeaderName }}</div>

            <div class="label">专业副总</div>
            <div class="value1">{{ extra.specVicePresidentName }}</div>
            <div class="label">管理级别</div>
            <div class="value2">
                <DataDictFinder dictType="cosys.manageLevel" :dictValue="extra.manageLevel" />
            </div>

        </div>
        <div class="specVicePresident">
            <div class="hintName">注：请选择相应专业副总确定项目管理级别。</div>
            <div class="hint">
                <span class="hintName">吴昊</span>：城市防洪、河道整治、水环境整治工程、给排水、环境卫生工程、规划工程管理；
                <span class="hintName">管凛</span>：智慧产业工程；</div>
            <div class="hint">
                <span class="hintName">韦春陆</span>：道路、桥梁、隧道、管廊、公共交通工程、公路；
                <span class="hintName">卢浩</span>：建筑、风景园林、人防、热力、燃气。
            </div>
        </div>
        <div class="panel">
            <div class="label">部门分管负责人</div>
            <div class="value1">{{ extra.deptLeaderName }}</div>
            <div class="label">公司分管领导</div>
            <div class="value2">{{ extra.companyLeaderName }}</div>

            <div class="label">分管总工</div>
            <div class="value3">{{ extra.chiefEngineerName }}</div>
            <div class="label">项目要求</div>
            <div class="value3">{{ extra.requirements }}</div>
        </div>
        <div class="specVicePresident">
            <div class="hintName">包括顾客要求、与建设项目有关的法律法规要求、建设项目的用途（包括预期用途）、公司要求等</div>
        </div>
        <Padding />
        <div>
            <Title>会签评审人员</Title>
            <a-form :model="form" layout="horizontal" :colon="false" label-align="right" :label-col="{ span: 6 }" :wrapper-col="{ span: 14 }">
                <a-row :gutter="16">
                    <a-col :span="12">
                        <a-form-item label="管理级别" prop="manageLevel" required :rules="[{ required: true, message: '请选择管理级别' }]">
                            <a-radio-group v-model="form.manageLevel" placeholder="项目选择后自动带出" @change="handleManageLevelChange" :disabled="isMajorViceDisabled">
                                <a-radio-button v-for="item in manageLevelList" :key="item.value" :value="item.value">{{ item.name }}</a-radio-button>
                            </a-radio-group>
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="项目类别" required prop="prjCategory" :rules="[{ required: true, message: '请选择项目类别' }]">
                            <a-radio-group v-model="form.prjCategory" placeholder="请选择" :disabled="isMajorViceDisabled">
                                <a-radio-button v-for="item in projectCategoryList" :key="item.value" :value="item.value">{{ item.name }}</a-radio-button>
                            </a-radio-group>
                        </a-form-item>
                    </a-col>
                </a-row>
            </a-form>
        </div>
        <div>
            <a-form :model="form" layout="horizontal" :colon="false" label-align="right" :label-col="{ span: 6 }" :wrapper-col="{ span: 14 }">
                <a-row :gutter="16">
                    <a-col :span="12">
                        <a-form-item label="部门分管负责人" prop="deptLeaderName" extra="部门分管负责人为部门正职或副职。" required :rules="[{ required: true, message: '请选择部门分管负责人' }]">
                            <a-select show-search :filter-option="$selectFilterOption" label-in-value :value="selectedMaster" placeholder="请选择部门分管负责人" @change="(val) => handlePersonnelSelect(val, 'deptLeader')" style="width: 100%" :disabled="isSubmitterDisabled">
                                <a-select-option v-for="item in personnel.masters" :key="item.userId" :value="item.userId">{{ item.name }}</a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="公司分管领导" prop="companyLeaderName" extra="公司管项目需要填写分管领导。" :required="isCompanyManageLevel" :rules="companyLeaderRules">
                            <a-select show-search :filter-option="$selectFilterOption" label-in-value :value="selectedCompanyChiefEngineer" placeholder="请选择公司分管领导" :disabled="!isCompanyManageLevel || isSubmitterDisabled" @change="(val) => handlePersonnelSelect(val, 'companyLeader')" style="width: 100%">
                                <a-select-option v-for="item in personnel.chargeLeaders" :key="item.userId" :value="item.userId">{{ item.name }}</a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="分管总工" prop="chiefEngineerName" extra="部门管项目填部门总工或副总工，公司管项目填公司分管总工。" required :rules="[{ required: true, message: '请选择分管总工' }]">
                            <a-select show-search :filter-option="$selectFilterOption" label-in-value :value="selectedDeptChiefEngineer" placeholder="请选择分管总工" @change="(val) => handlePersonnelSelect(val, 'chiefEngineer')" style="width: 100%" :disabled="isSubmitterDisabled">
                                <a-select-option v-for="item in (isCompanyManageLevel ? personnel.companyChiefEngineers : personnel.deptChiefEngineers)" :key="item.userId" :value="item.userId">{{ item.name }}</a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                </a-row>
            </a-form>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Title from "../Title";
import { getPersonnel, getCompanyPersonnel } from "@/api/project-approval/review";
import city from "@/mixins/city";
export default {
    mixins: [city],
    components: {
        Title,
    },
    data() {
        return {
            personnel: {
                masters: [],
                chargeLeaders: [],
                companyChiefEngineers: [],
                deptChiefEngineers: [],
            },
            selectedValues: {
                deptLeader: null,
                companyLeader: null,
                chiefEngineer: null,
            },
        };
    },
    computed: {
        ...mapState("approval", ["detail"]),
        ...mapGetters("setting", ["findDataDict"]),
        ...mapGetters("auth", ["department"]),
        deptId() {
            return this.department.deptId || '';
        },
        extra() {
            return this.detail.extra ? this.detail.extra : {};
        },
        isMajorVice() {
            return this.detail.taskDefinitionKey && this.detail.taskDefinitionKey.startsWith('major_vice');
        },
        isSubmitter() {
            return this.detail.taskDefinitionKey && this.detail.taskDefinitionKey.startsWith('submitter');
        },
        isMajorViceDisabled() {
            return !this.isMajorVice;
        },
        isSubmitterDisabled() {
            return !this.isSubmitter;
        },
        isCompanyManageLevel() {
            return this.form && this.form.manageLevel === 'company';
        },
        companyLeaderRules() {
            if (this.isCompanyManageLevel) {
                return [{ required: true, message: '请选择公司分管领导' }];
            }
            return [];
        },
        form() {
            return this.extra;
        },
        manageLevelList() {
            return this.findDataDict("cosys.manageLevel") || [];
        },
        projectCategoryList() {
            return this.findDataDict("cosys.prjCategory");
        },
        countryList() {
            return [
                { code: 'CN', name: '中国' },
                { code: 'HK', name: '中国香港' },
                { code: 'MO', name: '中国澳门' },
                { code: 'TW', name: '中国台湾' },
                { code: 'SG', name: '新加坡' },
                { code: 'MY', name: '马来西亚' },
                { code: 'TH', name: '泰国' },
                { code: 'VN', name: '越南' },
                { code: 'JP', name: '日本' },
                { code: 'KR', name: '韩国' },
                { code: 'US', name: '美国' },
                { code: 'GB', name: '英国' },
                { code: 'DE', name: '德国' },
                { code: 'FR', name: '法国' },
                { code: 'AU', name: '澳大利亚' },
                { code: 'CA', name: '加拿大' },
            ];
        },
        countryName() {
            const item = this.countryList.find(c => c.code === this.extra.country);
            return item ? item.name : this.extra.country;
        },
        areaName() {
            const names = [];
            if (this.extra.province) names.push(this.getCityNameById(this.extra.province));
            if (this.extra.city) names.push(this.getCityNameById(this.extra.city));
            if (this.extra.district) names.push(this.getCityNameById(this.extra.district));
            return names.filter(Boolean).join(' / ') || '';
        },

        selectedMaster() {
            if (this.selectedValues.deptLeader) return this.selectedValues.deptLeader;
            if (!this.extra.deptLeaderName) return undefined;
            const item = this.personnel.masters.find(i => i.name === this.extra.deptLeaderName);
            return item ? { key: item.userId, label: item.name } : { key: this.extra.deptLeaderName, label: this.extra.deptLeaderName };
        },
        selectedCompanyChiefEngineer() {
            if (this.selectedValues.companyLeader) return this.selectedValues.companyLeader;
            if (!this.extra.companyLeaderName) return undefined;
            const item = this.personnel.chargeLeaders.find(i => i.name === this.extra.companyLeaderName);
            return item ? { key: item.userId, label: item.name } : { key: this.extra.companyLeaderName, label: this.extra.companyLeaderName };
        },
        selectedDeptChiefEngineer() {
            if (this.selectedValues.chiefEngineer) return this.selectedValues.chiefEngineer;
            if (!this.extra.chiefEngineerName) return undefined;
            const list = this.isCompanyManageLevel ? this.personnel.companyChiefEngineers : this.personnel.deptChiefEngineers;
            const item = list.find(i => i.name === this.extra.chiefEngineerName);
            return item ? { key: item.userId, label: item.name } : { key: this.extra.chiefEngineerName, label: this.extra.chiefEngineerName };
        },
    },
    mounted() {
        this.fetchPersonnel();
    },
    methods: {
        fetchPersonnel() {
            const orgId = this.extra.prodDeptId;
            if (!orgId) return;
            const normalize = (arr) => (arr || []).filter(item => item.id).map(item => ({
                userId: String(item.id),
                name: item.name
            }));
            const mergeList = (apiList, extraName) => {
                const list = normalize(apiList);
                if (extraName && !list.some(item => item.name === extraName)) {
                    list.push({ userId: extraName, name: extraName });
                }
                return list;
            };
            // 分管总工候选人需包含项目总工（masterEngineer）
            const appendMasterEngineer = (list, source) => {
                if (!source || !source.masterEngineer) return list;
                const userId = String(source.masterEngineer);
                if (list.some(item => item.userId === userId)) return list;
                return list.concat([{ userId, name: source.masterEngineerName || userId }]);
            };
            if (this.isCompanyManageLevel) {
                // 公司管项目：分管总工候选人取自公司级人员接口
                Promise.all([getCompanyPersonnel(orgId), getPersonnel(orgId)]).then(([companyRes, res]) => {
                    this.personnel.masters = mergeList(res.masters, this.extra.deptLeaderName);
                    this.personnel.chargeLeaders = mergeList(res.chargeLeaders, this.extra.companyLeaderName);
                    this.personnel.companyChiefEngineers = appendMasterEngineer(mergeList(companyRes.companyChiefEngineers, this.extra.chiefEngineerName), companyRes);
                    this.personnel.deptChiefEngineers = appendMasterEngineer(mergeList(companyRes.deptChiefEngineers, this.extra.chiefEngineerName), companyRes);
                });
            } else {
                getPersonnel(orgId).then(res => {
                    this.personnel.masters = mergeList(res.masters, this.extra.deptLeaderName);
                    this.personnel.chargeLeaders = mergeList(res.chargeLeaders, this.extra.companyLeaderName);
                    this.personnel.companyChiefEngineers = appendMasterEngineer(mergeList(res.companyChiefEngineers, this.extra.chiefEngineerName), res);
                    this.personnel.deptChiefEngineers = appendMasterEngineer(mergeList(res.deptChiefEngineers, this.extra.chiefEngineerName), res);
                });
            }
        },
        handleManageLevelChange() {
            this.$set(this.selectedValues, 'companyLeader', null);
            this.$set(this.extra, 'companyLeaderId', null);
            this.$set(this.extra, 'companyLeaderName', null);
            this.$set(this.selectedValues, 'chiefEngineer', null);
            this.$set(this.extra, 'chiefEngineerId', null);
            this.$set(this.extra, 'chiefEngineerName', null);
            // 管理级别变更后重新拉取人员，切换分管总工候选人来源
            this.fetchPersonnel();
        },
        getCityNameById(id) {
            if (!id) return '';
            const item = (this.rawCityList || []).find(i => i.id === id);
            return item ? item.name : id;
        },
        handlePersonnelSelect(val, type) {
            if (!val) return;
            const map = {
                deptLeader: { key: 'deptLeader', idField: 'deptLeaderId', nameField: 'deptLeaderName', list: 'masters' },
                companyLeader: { key: 'companyLeader', idField: 'companyLeaderId', nameField: 'companyLeaderName', list: 'chargeLeaders' },
                chiefEngineer: { key: 'chiefEngineer', idField: 'chiefEngineerId', nameField: 'chiefEngineerName', list: 'deptChiefEngineers' },
            };
            const cfg = map[type];
            if (!cfg) return;
            this.$set(this.selectedValues, cfg.key, { key: val.key, label: val.label });
            this.$set(this.extra, cfg.idField, val.key);
            this.$set(this.extra, cfg.nameField, val.label);
        },
    },
    filters: {
        dateFormat(val) {
            if (!val) return '-';
            return new Date(val).toLocaleDateString();
        },
    },
};
</script>

<style lang="less" scoped>
.panel {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    border-top: 1px solid #e8e8e8;

    & > div {
        padding: 8px;
        border-bottom: 1px solid #e8e8e8;
    }

    .label {
        background-color: #fafafa;
        border-right: 1px solid #e8e8e8;
        border-left: 1px solid #e8e8e8;
    }

    .value1 {
        grid-column-start: 2;
        grid-column-end: 4;
    }

    .value2 {
        grid-column-start: 5;
        grid-column-end: 7;
        border-right: 1px solid #e8e8e8;
    }

    .value3 {
        grid-column-start: 2;
        grid-column-end: 7;
        border-right: 1px solid #e8e8e8;
    }
}
.specVicePresident{
    text-align: center;
    margin: 10px 0;
}
.hint {
    font-size: 12px;
    color: #999;
    line-height: 1.6;
    margin-top: 2px;
    padding-left: 8px;
}
.hintName{
    color: red;
    height: 25px;
    white-space: nowrap;
}
.hintText{
    margin-top: -10px!important;
    height:25px!important;
}
</style>
